import { Component, OnInit } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CreateTemplateComponent} from './create-template/create-template.component';
import {MediaLibraryComponent} from '../../media-library/media-library.component';
import {TemplateService} from '../shared/template.service';
import {Folder} from 'storyboard-renderer';
import {Template} from '../shared/template';
import {PromptModalComponent} from '../../shared/prompt-modal/prompt-modal.component';
import {StoryboardService} from "../../storyboard/shared/storyboard.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {Storyboard} from "storyboard-renderer";
import {TemplateFolderSubscriptionService} from "../shared/template-folder-subscription.service";

@Component({
  selector: 'app-template-list',
  templateUrl: './template-list.component.html',
  styleUrls: ['./template-list.component.scss'],
  providers: [TemplateService]
})
export class TemplateListComponent implements OnInit {

  subscribedFolders: Array<Folder> = [];
  folders: Array<Folder> = [];
  rootFolder: Folder = new Folder(0, 'root_folder');
  templateLoading = true;

  uncategorizedFolderDropzoneHidden = true;

  creatingFolder = false;

  constructor(private modalService: NgbModal, private templateService: TemplateService,
              private storyboardService: StoryboardService, private router: Router, private activatedRoute: ActivatedRoute,
              private subscriptionService: TemplateFolderSubscriptionService) {}

  ngOnInit() {

    //Check Sharing

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if(params.share && params.shared_folder) {
        this.subscriptionService.create(params.share, params.shared_folder).then(() => {
          this.getTemplates();
        }).catch((err) => {
          const modalRef = this.modalService.open(PromptModalComponent);
          modalRef.componentInstance.yesTitle = 'Close';
          modalRef.componentInstance.hideNo = true;
          modalRef.componentInstance.body = 'Subscribe url is wrong or revoked!';
        });
      }
    });

    // Load all storyboards
    this.getTemplates();
  }

  open() {
    const modalRef = this.modalService.open(CreateTemplateComponent, { size: 'lg' });
    modalRef.componentInstance.name = 'Crate Template';

    modalRef.result.then((result) => {
      this.getTemplates();
    });
  }

  openMediaLibrary() {
    const modalRef = this.modalService.open(MediaLibraryComponent, { size: 'lg' });
    modalRef.componentInstance.name = 'Media Library';
  }

  getTemplates(): void {

    this.templateLoading = true;

    this.templateService.getTemplatesInFolderedStructure().then(folderContainer => {

      this.folders = folderContainer.folders.filter((item: any) => !item.subscription);
      this.rootFolder = folderContainer.rootFolder;
      this.subscribedFolders = folderContainer.folders.filter((item: any) => item.subscription);

      this.templateLoading = false;
    }, () => {
      this.templateLoading = false;
    });
  }

  moveItem($event: any, folder: Folder) {
    if ($event) {

      folder.items.push($event.dragData.item);
      $event.dragData.item.folder = new Folder(folder.id, folder.title);

      const index = $event.dragData.folder.items.indexOf($event.dragData.item);
      $event.dragData.folder.items.splice(index, 1);

      this.templateService.update($event.dragData.item).then(template => {

        const info = console.info.bind(console);
        info('update', template);

      });
    }

    this.hideDropzoneForUncategorizedFolder();
  }

  showDropzoneForUncategorizedFolder(){
    this.uncategorizedFolderDropzoneHidden = false;
  }
  hideDropzoneForUncategorizedFolder(){
    this.uncategorizedFolderDropzoneHidden = true;
  }

  delete(template: Template): void {

    const modalRef = this.modalService.open(PromptModalComponent).result.then((result) => {
      this.templateService
          .delete(template)
          .then(templates => {
            this.getTemplates();
          })
    });
  }

  unsubscribed(folder): void {
    this.subscribedFolders = this.subscribedFolders.filter(item => item.id !== folder.id);
  }


  duplicate(item) {

    const newTemplate = Template.fromJson(JSON.parse(JSON.stringify(item)));
    newTemplate.title = newTemplate.title + ' copy';

    if(item.read_only) {
      newTemplate.folder = null;
    }

    this.templateService.create(newTemplate).then(template => {
      this.getTemplates();
    });
  }

  createStoryboardFromTemplate(item) {

    const newStoryboard = Storyboard.fromJson(JSON.parse(JSON.stringify(item)));
    newStoryboard.folder = null;
    newStoryboard.title = newStoryboard.title + ' copy';

    this.storyboardService.create(newStoryboard).then(storyboard => {
      this.router.navigate(['/storyboard', storyboard.id]);
    });
  }

  newFolder() {
    this.creatingFolder = !this.creatingFolder;
  }

  deleteFolder(folder: Folder): void {

    const modalRef = this.modalService.open(PromptModalComponent).result.then((result) => {

      this.templateService
          .deleteFolder(folder)
          .then(() => {
            this.getTemplates();
          });
    });
  }

  cancelCreateFolder() {
    this.creatingFolder = false;
    // TODO cancel folder creating
  }

  saveFolder(event) {
    this.creatingFolder = false;

    const newFolder: Folder = new Folder(0, event.folderName);

    this.templateService.createFolder(newFolder).then((folder) => {
      this.folders.push(folder);
    });


  }

  isFolderForUncategorizedItems(folder: Folder){
    return folder && !folder.folder;
  }

  checkFolderExists() {
    return !this.templateLoading &&
           !this.creatingFolder &&
           (this.folders.length === 0 || (this.folders.length === 1 && !this.folders[0].items.length)) &&
           !this.subscribedFolders.length;
  }

}



// WEBPACK FOOTER //
// ./src/app/template/template-list/template-list.component.ts